export const environment = {
  production: true,
  baseUrl: "https://prodapi.askiitians.com/api",
  nodeBaseUrl: 'https://nodeapi.askiitians.com/api',
  // baseUrl: "https://apistaging.askiitians.com/api",
  // baseUrl: "https://localhost:44305/api",
  blogUrl: "https://www.askiitians.com/blog/",
  sms_factorkey: "",
  siteBaseDomain: "https://www.askiitians.com/",
  GATrackingID: "UA-70930152-1", // Google Tracking Id
  GTagManagerId: "GTM-TQCDPSGK", // Google Tag manager Id
  GoogleClientId: "872727131907-hlpgb5puoq6g463dv1te0sfe3t1519iu.apps.googleusercontent.com",
  ChatPortAppId: "63f5e4e54396224c964e2745", // Chat Port AppId
  RedisServerURL: "redis://10.0.0.10:6379",
  RedisServerPassword: "8vPIoEuTuICNP0Q",
  cacheExpirytime: 86400,
  hostDomain: "https://www.askiitians.com/",
  Paypal_ClientId: "AeIIBJwvne9rXIdWshqoJZEK8IA57h7CTx3TJC5IzKzQ8AJC6etjugIFKaAJhlSKCAE5kkNrqNYfzSwQ",
  connectToCounsellor: 5000,
  showctcOntime: false,
  GoogleRE_CAPTCHA_KEY: "6Ld3f9grAAAAAEIcc2dic86mJ4Bbyeu5Yso4iOQ9",
  GoogleRE_CAPTCHA_IsEnabled: true,
  GPTAnswerId: "769761",
  otpDeliveryMode: 'email',
  firebase: {
    apiKey: 'AIzaSyD7UdBAnqUenNxSTDdUy8DITZRdgpo7VJs',
    authDomain: 'askiitians-web.firebaseapp.com',
    projectId: 'askiitians-web',
    appId: '1:656606676575:web:fc4edf971ff5cbd27e3dea',
    messagingSenderId: '656606676575',
    storageBucket: 'askiitians-web.firebasestorage.app',
  },
  r2PublicBaseUrl: 'https://files.askiitians.com'
};